// For Development
// export const SUCCESS_URL = 'http://127.0.0.1:3000/booking/payment/success';
// export const FAILED_URL = 'http://127.0.0.1:3000/booking/payment/failed';

// For Dev Remote
// export const SUCCESS_URL =
//   'https://emstelldemo.com/booking/payment/success';
// export const FAILED_URL =
//   'https://emstelldemo.com/booking/payment/failed';

// For Production server
export const SUCCESS_URL =
  'https://emstell.com/emstell-workshop/booking/payment/success';
export const FAILED_URL =
  'https://emstell.com/emstell-workshop/booking/payment/failed';

// For Production
// export const
